import CarnetDetailController from './carnet.detail.controller';

export default {
    template: require('./carnet.detail.html'),
    controller: CarnetDetailController
};
